import styled, { css } from 'styled-components';

export const FarelockBtn = styled.button`
  background: linear-gradient(
    to right,
    #802d00,
    #d37e41 70%,
    #fbb076 78%,
    #d68044 87%,
    #792c00 93%
  );
  border-radius: 4px;
  color: #122dff;
  display: inline-block;
  padding: ${props => props.theme.spacing.custom(1)};
  text-decoration: none;
  border: none;
  font-size: ${props => (props.rndTRip ? '16px' : '14px')};
  cursor: pointer;
  margin-bottom: 5px;
  margin-right: ${props => (props.rndTRip ? '10px' : '0')};
  margin-top: ${props => props.theme.spacing.custom(8)};
  .btnText {
    ${props => {
      if (Array.isArray(props.bgColor)) {
        return css`
          background: ${props.bgColor.length === 1
            ? props.bgColor[0]
            : `linear-gradient(90deg, ${props.bgColor.join(',')})`};
        `;
      }
    }}
    border-radius: 3px;
    color: #8b3c11;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${props => (props.rndTRip ? '13px 6px' : '8px 6px')};
    width: 100%;
  }
`;
